// extracted by mini-css-extract-plugin
export default {"execute_btn":"styles_execute_btn__ZpiJk","cancel_btn":"styles_cancel_btn__yo2CL","content_container":"styles_content_container__KYKYA","text":"styles_text__XScdg"};